import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_CLEAR_FILTERS,
  FACILITATOR_VALIDATION_SET_SELECTED_DOMAIN_ID,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTERS,
} from '../../../../../actions/actionTypes';
import { castFunctionHelper } from '../../helpers/filterHelpers';

const defaultState = null;
const key = 'domainId';

const domainId = (state = defaultState, action) => {
  switch (action.type) {
    case FACILITATOR_VALIDATION_CLEAR:
    case FACILITATOR_VALIDATION_CLEAR_FILTERS:
    case FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER:
      return defaultState;

    case FACILITATOR_VALIDATION_SET_SELECTED_DOMAIN_ID:
    case FACILITATOR_VALIDATION_SET_SELECTED_FILTERS:
      return castFunctionHelper(key, defaultState, action);

    default:
      return state;
  }
};

export default domainId;
